module.exports = __webpack_public_path__ + "static/VasudevanSuresh-425759881a23a5044cc1d0c1761ab139.jpg";